export enum InlineModuleTypeEnum {
	FORM = 'form',
	DOCUMENT = 'document',
	RECALL = 'recall',
	COMPONENT = 'component',
}
